module.exports = __webpack_public_path__ + "img/laser_violeta.35d74434.jpeg";